import { put, takeLatest } from "redux-saga/effects";

export const actionTypes = {
  SET_PLAN_FEATURES: "SET_PLAN_FEATURES",
};

const initialPlanState = {
  features: null,
};

export const reducer = (state = initialPlanState, action) => {
  switch (action.type) {
    case actionTypes.SET_PLAN_FEATURES: {
      const { features } = action.payload;
      return { features };
    }
    default:
      return state;
  }
};

export const actions = {
  setFeatures: (features) => ({ type: actionTypes.SET_PLAN_FEATURES, payload: { features } })
};

export function* saga() {
  yield takeLatest(actionTypes.SET_PLAN_FEATURES, function* setFeaturesSaga() {
    yield put(actions.setFeatures());
  });
}
